import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getProductList = createAsyncThunk(
  "get-product",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("product/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createProduct = createAsyncThunk(
  "create-product",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("product", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdProduct = createAsyncThunk(
  "edit-product",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`product/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateProduct = createAsyncThunk(
  "update-product",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/product/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateProductStatus = createAsyncThunk(
  "update-product-status",
  async (id, { dispatch }) => {
    try {
      const response = await axios.put(`/product/update/status/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "delete-product",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/product/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteProductContact = createAsyncThunk(
  "delete-contact",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/product/contact/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const productSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProductList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProductList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.productList?? [];
        state.perPage = action?.payload?.data?.data?.perPage?? 1;
        state.total = action?.payload?.data?.data?.total?? 0;
      })
      .addCase(getProductList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default productSlice.reducer;
